export const INITIAL_FORGOT = "INITIAL_FORGOT";
export const CHANGE_FORGOT_PHONE = "CHANGE_FORGOT_PHONE";
export const CHANGE_FORGOT_VALIDATE = "CHANGE_FORGOT_VALIDATE";
export const CHANGE_FORGOT_PASSWORD = "CHANGE_FORGOT_PASSWORD";
export const CHANGE_FORGOT_CONFIRM = "CHANGE_FORGOT_CONFIRM";
export const ERROR_FORGOT_CONFIRM = "ERROR_FORGOT_CONFIRM";
export const SHOW_FORGOT_PASSWORD = "SHOW_FORGOT_PASSWORD";
export const SHOW_FORGOT_CONFIRM = "SHOW_FORGOT_CONFIRM";
export const SUBMIT_FORGOT_PHONE = "SUBMIT_FORGOT_PHONE";
export const SUBMIT_FORGOT_VALIDATION = "SUBMIT_FORGOT_VALIDATION";
export const SUBMIT_FORGOT_PASSWORD = "SUBMIT_FORGOT_PASSWORD";